import React from "react";
import styled from "styled-components";
import { withTranslation, WithTranslation } from "react-i18next";
import { Element } from "react-scroll";

import { H2Pre, Body1Pre, Button } from "src/components/Typography";
import { colors } from "src/styles/colors";
import { media } from "src/utils/media";
import { translate } from "src/locales";
import { gTagEvent, ActionType, CategoryType } from "src/configs/analytics";
import TypeformButton from "src/components/TypeformButton";
import { getTalkSalesFormUri } from "src/utils/uri";

type Props = WithTranslation;

const Container = styled(Element)`
  display: flex;
  background-color: ${colors.bg.white.sub};
  min-width: 1440px;
  ${media.mobile`
    min-width: auto;
  `}
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1352px;
  padding-top: 200px;
  padding-bottom: 204px;
  margin: auto;
  ${media.mobile`
    flex-direction: column;
    width: 327px;
    padding-top: 108px;
    padding-bottom: 108px;
  `}
`;

const Title = styled(H2Pre)`
  color: ${colors.text.dark.title};
  ${media.mobile`
    min-width: 248px;
    text-align: center;
  `}
`;

const Description = styled(Body1Pre)`
  text-align: center;
  color: ${colors.text.dark.body};
  margin-top: 24px;
  ${media.mobile`
    min-width: 194px;
    text-align: center;
    margin-top: 20px;
  `}
`;

const ConfirmButton = styled(TypeformButton)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 56px;
  padding-right: 56px;
  height: 72px;
  color: #ffffff;
  background: ${colors.primary.default};
  box-shadow: 0px 10px 40px rgba(54, 62, 76, 0.05);
  border-radius: 100px;
  margin-top: 48px;
  margin-left: auto;
  margin-right: auto;
  transition: all 0.15s linear 0s;
  cursor: pointer;
  &:hover {
    background: ${colors.primary.hover};
  }
  ${media.mobile`
    padding-left: 38px;
    padding-right: 38px;
    height: 54px;
    margin-top: 36px;
    margin-left: auto;
    margin-right: auto;
  `}
`;

const TryItSection = (props: Props) => {
  const { i18n, t } = props;
  const isKo = i18n.language === "ko";

  const onLink = () => {
    gTagEvent({
      category: CategoryType.Last,
      action: ActionType.CTA,
      label: "TALK TO SALES",
    });
  };

  return (
    <Container id="tryIt" name="tryIt">
      <Inner>
        <Title>{translate(["tryItSection", "title"], t)}</Title>
        <ConfirmButton typeformUri={getTalkSalesFormUri(isKo)} onClick={onLink}>
          {translate(["tryItSection", "confirmButton"], t)}
        </ConfirmButton>
      </Inner>
    </Container>
  );
};

export default withTranslation()(TryItSection);
